import React from 'react';
import { css } from '@emotion/react';

import { ltColors, ltFont } from './styles';

type ErrorStateProps = {
  message?: string | null;
  onRetry: () => void;
};

const styles = css`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 24px;
  font-family: ${ltFont};
  color: ${ltColors.white};

  .lt-badge-err {
    width: 76px;
    height: 76px;
    border-radius: 22px;
    background: ${ltColors.yellow};
    color: ${ltColors.navy};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 34px;
    margin-bottom: 22px;
    box-shadow: 0 8px 0 rgba(0, 0, 0, 0.18);
  }
  h2 { font-weight: 600; font-size: 24px; margin: 0 0 8px; color: ${ltColors.white}; }
  p { font-size: 16px; opacity: 0.8; margin: 0 0 22px; max-width: 340px; }
  button {
    border: none;
    cursor: pointer;
    background: ${ltColors.pink};
    color: ${ltColors.white};
    font-family: ${ltFont};
    font-weight: 600;
    font-size: 15px;
    padding: 12px 24px;
    border-radius: 999px;
  }
`;

const ErrorState: React.FC<ErrorStateProps> = ({ message, onRetry }) => (
  <div css={styles}>
    <div className='lt-badge-err'><i className='icon icon-warning' aria-hidden='true' /></div>
    <h2>We couldn&apos;t generate your takeaway yet</h2>
    <p>{message || 'Something went wrong while preparing your report. You can try again in a moment.'}</p>
    <button type='button' onClick={onRetry}>Try again</button>
  </div>
);

export default ErrorState;
